// Botão do Atendimento (2026-07-15): liga/desliga a atribuição automática de
// líder 24/7. LIGADO, todo lead que completa o cadastro é entregue na hora
// (sweeper de 3 min) a uma líder/empresária do pool Pareto (tier C fora, A
// prioritário, B quando não há A no raio; score = carga 7d + proximidade).
// DESLIGADO, vale só a regra fora-do-expediente (toggle admin, painel Sistema).
// Backend: GET/PUT /api/settings/auto-assign-247 (system_settings.auto_assign_247).
import { useState, useEffect, useCallback } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { FiUserCheck, FiLoader } from 'react-icons/fi'

// neu: tema neumórfico — vira botão só-ícone (sem o rótulo "Auto-líder"), com
// relevo de clicável; o pontinho de status continua indicando ligado/desligado.
export function AutoAssign247Toggle({ neu = false }: { neu?: boolean } = {}) {
  const { authenticatedFetch } = useAuth()
  const [enabled, setEnabled] = useState<boolean | null>(null)
  const [busy, setBusy] = useState(false)

  const load = useCallback(async () => {
    try {
      const r = await authenticatedFetch('/api/settings/auto-assign-247')
      const d = await r.json()
      if (d.success) setEnabled(!!d.enabled)
    } catch { /* mantém estado desconhecido */ }
  }, [authenticatedFetch])

  useEffect(() => { load() }, [load])

  const toggle = async () => {
    if (busy || enabled === null) return
    setBusy(true)
    try {
      const r = await authenticatedFetch('/api/settings/auto-assign-247', {
        method: 'PUT',
        body: JSON.stringify({ enabled: !enabled }),
      })
      const d = await r.json()
      if (r.ok && d.success) setEnabled(!!d.enabled)
    } catch { /* segue como estava */ }
    finally { setBusy(false) }
  }

  return (
    <button
      onClick={toggle}
      disabled={busy || enabled === null}
      className={neu
        ? `relative inline-flex items-center justify-center w-9 h-9 rounded-lg transition-all text-xs font-medium disabled:opacity-50 neu-relief ${
            enabled ? 'bg-emerald-500/15 text-emerald-600' : 'text-muted-foreground'
          }`
        : `flex items-center gap-1.5 px-3 py-2 backdrop-blur-md rounded-xl transition-all shadow-sm text-xs font-medium disabled:opacity-50 ${
            enabled
              ? 'bg-emerald-500/15 text-emerald-600 hover:bg-emerald-500/25'
              : 'bg-card text-muted-foreground hover:bg-accent'
          }`}
      title={enabled
        ? 'Atribuição automática 24/7 LIGADA: lead com cadastro completo é entregue em até 3 min a uma líder/empresária do pool Pareto (tiers A/B, score + proximidade), a qualquer hora. Clique para desligar.'
        : 'Atribuição automática 24/7 DESLIGADA: leads em horário comercial seguem na triagem manual (fora do expediente vale a regra automática atual). Clique para ligar a entrega imediata.'}
    >
      {busy ? <FiLoader className="w-3.5 h-3.5 animate-spin" /> : <FiUserCheck className="w-3.5 h-3.5" />}
      {!neu && <span className="hidden sm:inline">Auto-líder</span>}
      {/* Status: no neu vira um ponto no canto (o botão é só-ícone). */}
      <span className={`rounded-full ${neu ? 'absolute top-1 right-1 w-1.5 h-1.5' : 'w-1.5 h-1.5'} ${enabled ? 'bg-emerald-500' : 'bg-muted-foreground/40'}`} />
    </button>
  )
}
